/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Render_Audio_Complete_ToastInputs */



/**
* | output |
* | --- |
* | "Converting text to speech audio complete" |
*
* @param {Render_Audio_Complete_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const render_audio_complete_toast = /** @type {((inputs?: Render_Audio_Complete_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Render_Audio_Complete_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Conversion du texte en audio terminee")
	if (locale === "de") return /** @type {LocalizedString} */ ("Umwandlung von Text in Sprachaudio abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Conversione del testo in audio vocale completata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Преобразование текста в речь завершено.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Conversión completa de texto a audio de voz")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文本转语音音频转换完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキストを音声に変換しています")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेक्स्ट को ऑडियो स्पीच में परिवर्तित करने की प्रक्रिया पूरी हो गई है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Conversão de texto em áudio de fala concluída")
	return /** @type {LocalizedString} */ ("Converting text to speech audio complete")
});